import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import ExpandIcon from '../../../components/common/ExpandIcon';
import TextField from '../../../components/common/TextField';
import { open } from '../../../modules/modal/actions';
import { isAuthenticated } from '../../../modules/user/selectors';
import { saveSlipButtonClicked, slipHide, slipShow, slipStakeChanged } from '../actions';
import {
  getCurrentSlipPotentialReturns,
  getCurrentSlipSize,
  getCurrentSlipStake,
  getCurrentSlipStakeErrors
} from '../selectors';

export class NewSlipWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.saveAction = this.saveAction.bind(this);
  }

  saveAction() {
    const { userAuthenticated, onSaveSlipButtonClick, onSaveAnonInfo } = this.props;

    if (userAuthenticated) {
      onSaveSlipButtonClick();
    } else {
      onSaveAnonInfo();
    }
  }

  render() {
    const {
      expanded,
      slipSize,
      slipStake,
      slipStakeErrors,
      potentialReturns,
      onStakeChange,
      onViewSlip,
      onCloseSlip
    } = this.props;

    if (!slipSize) {
      return null;
    }

    return (
      <div className="new-slip-widget">
        <div className="new-slip-widget__header">
          <div className="new-slip-widget__selections">
            {slipSize} {slipSize === 1 ? 'Selection' : 'Selections'}
          </div>
          <div className="new-slip-widget__returns">
            Returns: £{potentialReturns.toFixed(2)}
          </div>
          <div className="new-slip-widget__switcher" onClick={expanded ? onCloseSlip : onViewSlip}>
            {expanded ? 'Close Slip' : 'View Slip'}
            <ExpandIcon expanded={!expanded} className="expand-icon--white" />
          </div>
        </div>
        <div className="new-slip-widget__form">
          <div className="new-slip-widget__label">Stake</div>
          <div className="new-slip-widget__input-container">
            <TextField
              name="slip-stake"
              value={slipStake}
              onChange={onStakeChange}
              className="new-slip-widget__input needsclick"
              errors={slipStakeErrors}
              currency="£"
              theme="small"
            />
          </div>
          <Button
            disabled={slipStakeErrors.length > 0}
            onClick={this.saveAction}
            className="new-slip-widget__button"
          >
            Save Slip
          </Button>
        </div>
      </div>
    );
  }
}

NewSlipWidget.propTypes = {
  expanded: PropTypes.bool,
  slipSize: PropTypes.number,
  slipStake: PropTypes.string,
  slipStakeErrors: PropTypes.arrayOf(PropTypes.string),
  potentialReturns: PropTypes.number,
  userAuthenticated: PropTypes.bool,
  onStakeChange: PropTypes.func,
  onSaveSlipButtonClick: PropTypes.func,
  onSaveAnonInfo: PropTypes.func,
  onViewSlip: PropTypes.func,
  onCloseSlip: PropTypes.func
};

NewSlipWidget.defaultProps = {
  expanded: false,
  slipSize: 0,
  slipStake: '0',
  slipStakeErrors: [],
  potentialReturns: 0,
  userAuthenticated: false,
  onStakeChange: () => {
  },
  onSaveSlipButtonClick: () => {
  },
  onSaveAnonInfo: () => {
  },
  onViewSlip: () => {
  },
  onCloseSlip: () => {
  }
};

const mapStateToProps = state => ({
  slipSize: getCurrentSlipSize(state),
  slipStake: getCurrentSlipStake(state),
  slipStakeErrors: getCurrentSlipStakeErrors(state).toJS(),
  potentialReturns: getCurrentSlipPotentialReturns(state),
  userAuthenticated: isAuthenticated(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onStakeChange: (e) => dispatch(slipStakeChanged(e)),
  onSaveSlipButtonClick: () => dispatch(saveSlipButtonClicked()),
  onSaveAnonInfo: () => dispatch(open({ componentName: 'AnonSaveSlip' })),
  onViewSlip: () => {
    dispatch(slipShow());
    ownProps.onViewSlip();
  },
  onCloseSlip: () => {
    dispatch(slipHide());
    ownProps.onCloseSlip();
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewSlipWidget));
